<template>
    <div v-if="initialCalcHeight > 0">
        <div class="show-more__txt-wrapper" :class="{'show-more__txt-wrapper--closed': !open }" :style="{ 'max-height': (isPreview ? 'unset' : (open ? initialCalcHeight : closedHeight) + 'px')}">
            <slot></slot>
        </div>
        <div v-if="initialCalcHeight > closedHeight" class="show-more__btn-wrapper" :style="{'justify-content': positionCenter === '1' ? 'center' : 'unset'}">
            <div v-if="!open" @click="open = !open" class="show-more__btn">{{ btnTxt1 }}</div>
            <div v-if="open" @click="open = !open" class="show-more__btn">{{ btnTxt2 }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
          return{
              open: false,
              initialCalcHeight: 1,
          }
        },

        props: {
            btnTxt1: {
                type: String,
                default: 'Mehr Anzeigen'
            },
            btnTxt2: {
                type: String,
                default: 'Weniger Anzeigen'
            },
            positionCenter: String,
            closedHeight: String,
            isPreview: {
                type: Boolean,
                default: false
            }
        },

        mounted(){
            this.$nextTick(() => {
                this.initialCalcHeight = this.calcHeight();
                if (this.initialCalcHeight <= this.closedHeight){
                    this.open = true;
                }
            })
        },

        methods: {

            calcHeight(){
                 return this.$slots.default[0].elm.clientHeight;

            },
        }
    }
</script>
